@if (picture()) {
  <img
    width="32"
    height="32"
    [alt]="'app.imgAlt.avatar' | translate"
    [ngSrc]="picture()"
    [appTooltip]="tooltipText() || null"
    [position]="TooltipPosition.BELOW"
  />
} @else if (fullName()) {
  <div
    class="user-name-first-latter"
    [appTooltip]="tooltipText() || null"
    [position]="TooltipPosition.BELOW"
  >{{ getInitials() }}</div>
} @else {
  <span></span>
}
